<app-cards>
  <app-card [selected]="selectedOptions[option.id]" *ngFor="let option of options" (click)="toggleSelection(option)">
    <h2 class="h4 text-center text-uppercase">{{option.label}}</h2>
  </app-card>

  <app-card [selected]="!!this.customValue" (click)="openDialog()">
    <h2 class="h4 text-center text-uppercase" i18n="@@discriminationTypeOther:Anders">Anders</h2>
  </app-card>
</app-cards>
